// extracted by mini-css-extract-plugin
module.exports = {"container":"e_3x","up":"e_4x","down":"e_5x","percent":"e_6x","percentVal":"e_7x","title":"e_8x","tags":"e_9x","textBadge":"e_-x"};